/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_SubmitInputs */

const en_cad_submit = /** @type {(inputs: Cad_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm new date`)
};

const ja_cad_submit = /** @type {(inputs: Cad_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい日付を確定`)
};

const fr_cad_submit = /** @type {(inputs: Cad_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer la nouvelle date`)
};

const de_cad_submit = /** @type {(inputs: Cad_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuen Termin bestätigen`)
};

/**
* | output |
* | --- |
* | "Confirm new date" |
*
* @param {Cad_SubmitInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cad_submit = /** @type {((inputs?: Cad_SubmitInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_SubmitInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cad_submit(inputs)
	if (locale === "ja") return ja_cad_submit(inputs)
	if (locale === "fr") return fr_cad_submit(inputs)
	return de_cad_submit(inputs)
});